import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DeletedWarningProps {
  show?: boolean;
  title?: string;
  description?: string;
  actions?: React.ReactNode;
}

export default function DeletedWarning({
  show,
  title,
  description,
  actions,
}: DeletedWarningProps) {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Alert className="bg-yellow-100 text-yellow-900 border-yellow-300">
      <Trash2 className="w-5 h-5" color="#713f12" />
      <AlertTitle>{title ?? t("common.deleted.title")}</AlertTitle>
      <AlertDescription className="flex flex-wrap items-center justify-between gap-2">
        <div>{description ?? t("common.deleted.description")}</div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </AlertDescription>
    </Alert>
  );
}
